import { jsx as _jsx } from "react/jsx-runtime";
const CLASS = {
    A: "bg-ok-soft text-ok",
    B: "bg-paper text-ink border border-line",
    C: "bg-warn-soft text-warn",
    S: "bg-danger-soft text-danger",
    F: "bg-ink text-paper",
    AB: "bg-transparent text-slate2 border border-dashed border-line text-[10px]",
};
export default function GradeBadge({ g }) {
    if (!g)
        return _jsx("span", { className: "grade-badge bg-transparent text-slate2/50 border border-dashed border-line", children: "\u00B7" });
    return _jsx("span", { className: `grade-badge ${CLASS[g]}`, children: g });
}
